import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import ResourceTabs from '@shell/components/form/ResourceTabs/index.vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import Conditions from '@shell/components/form/Conditions.vue';

/**
 * The standard tabs wrapper for every cert-manager detail page.
 *
 * ResourceTabs decides the Conditions tab's alert icon from `status.conditions[].error`, which
 * Steve only populates for resource types it knows. Ours arrive unclassified, so the tab is
 * supplied here instead and driven by the model's own condition judgement.
 *
 * Resources without conditions (the ACME Order and Challenge use `status.state`, not conditions)
 * simply fall through the `v-if` and get no Conditions tab, so this is safe to use everywhere.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'CertManagerResourceTabs',
  props: {
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResourceTabs, {
    value: __props.value,
    "need-conditions": false
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _cache[0] || (_cache[0] = _createTextVNode()),
      (__props.value.status?.conditions?.length)
        ? (_openBlock(), _createBlock(Tab, {
            key: 0,
            name: "conditions",
            "label-key": "resourceTabs.conditions.tab",
            weight: -1,
            "display-alert-icon": __props.value.conditionsHaveIssues
          }, {
            default: _withCtx(() => [
              _createVNode(Conditions, { value: __props.value }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["display-alert-icon"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["value"]))
}
}

})